import { buildSentryLogger } from './sentry';

export const Logger = buildSentryLogger();
